import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthCallback = () => {
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/', { replace: true });
          return;
        }

        // Call backend to process session
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );

        const user = response.data.user;

        // Store session token
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
        }

        // Redirect based on role
        if (user.role === 'super_admin') {
          navigate('/admin', { replace: true, state: { user } });
        } else if (user.role === 'admin') {
          navigate('/dashboard', { replace: true, state: { user } });
        } else {
          // Employees go to their company's impact website
          if (user.business_id) {
            navigate(`/impact/${user.business_id}`, { replace: true });
          } else {
            navigate('/', { replace: true });
          }
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/', { replace: true });
      }
    };

    processSession();
  }, [navigate, BACKEND_URL]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
